import { ModuleGroupEnum, ModuleIcon } from "@/includes/logic/Modules/types";
import ModuleBuilder from "@/includes/logic/Modules/modules/ModuleBuilder"
import CloseChatHandlerModule from "./CloseChatHandlerModule";
import i18n from "@/i18n/i18n";

import { TagData } from "piramis-base-components/src/components/Tags/types";

export default class CloseChatHandlerModuleBuilder extends ModuleBuilder {
  model!: CloseChatHandlerModule;

  view: ModuleBuilder['view'] = () => import('./CloseChatHandlerModuleView.vue')

  group: ModuleGroupEnum = ModuleGroupEnum.Extra

  icon: ModuleIcon = {
    type: "Pack",
    name: 'dark_mode',
    pack: "material-icons",
    iconStyle: "outlined",
  }

  aliases = [ 'Закрыть чат', 'Беззвучный', 'Беззвучный режим', 'ночной режим', 'ночно', 'Тишина', 'Ночной режим', 'закрытие чата' ]

  tariffTags(): Array<TagData> | null {
    return this.checkLimitOption('close_chat')
  }
}

